import styled from '@emotion/styled';
import { Modal, theme } from '@ublend-npm/aulaui-next';

type LoaderContainerProps = Readonly<{
  centerOffset: string;
}>;

export const LoaderContainer = styled.div<LoaderContainerProps>`
  position: absolute;
  top: ${({ centerOffset }) => `calc(50% - ${centerOffset})`};
  left: ${({ centerOffset }) => `calc(50% - ${centerOffset})`};
  z-index: 0;
`;

export const ContentContainer = styled.div`
  position: relative;
  height: 100%;
  overflow: auto;
`;

export const ContentHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spacing.xLarge};
`;

export const ContentHeader = styled.h2`
  margin-top: 0;
  margin-bottom: 0;
  font-weight: ${theme.font.weight.medium};
`;

export const HelpLink = styled.div`
  display: flex;
  white-space: pre-wrap;
  margin-bottom: ${theme.spacing.xLarge};

  > a {
    display: inline-flex;
    align-items: end;
    white-space: pre-wrap;
    color: ${theme.color.designSystem.purple80};
  }

  @media (max-width: 762px) {
    display: block;
  }
`;

export const FormErrorMessage = styled.p`
  padding: ${theme.spacing.medium};
  background-color: ${theme.color.designSystem.background.light.error};
  text-align: left;
  border-radius: ${theme.borderRadius.large};
  font-size: ${theme.font.size.large};
  line-height: 26px;
  color: ${theme.color.designSystem.content.light.error};
`;

/** Same shell as Materials / VitalSource-style DL picker. */
export const StyledModal = styled(Modal)`
  div[class*='itemDefault-Modal'] {
    padding: ${theme.spacing.xLarge};
    border-radius: 16px;
    height: 80%;
    min-width: 80%;
  }
`;

export const IFrame = styled('iframe')`
  z-index: 1;
  position: relative;
  border: none;
  width: 100%;
  height: calc(100% - 112px);

  @media (max-width: 762px) {
    height: calc(100% - 150px);
  }

  @media (max-width: 472px) {
    height: calc(100% - 162px);
  }
`;
